<script setup lang="ts">
import {ref, computed, onMounted, watch, nextTick} from "vue";
import YachtsHero from "@/pages/Yachts/YachtsHero.vue";
import CharterYachtComponent from "@/components/YachtComponent/CharterYachtComponent.vue";
import CustomButton from "@/components/Button/Button.vue";
import SearchResults from "@/components/SearchResults/SearchResults.vue";
import {VueAwesomePaginate} from "vue-awesome-paginate";
import {useYachtStore} from "@/stores/yachtStore";
import {useRoute, useRouter} from 'vue-router';
import {useWindowSize} from "@vueuse/core";
import {useSearchStore} from "@/stores/searchStore";
import {VueSpinner} from "vue3-spinners";


const yachtStore = useYachtStore();
const searchStore = useSearchStore();


const router = useRouter();
const route = useRoute();


const { width } = useWindowSize();
const isMobileSmall = computed(() => width.value < 1024);





onMounted(() => {
  searchStore.setFromQuery(route.query)
  searchStore.getAllYachts();
});

watch(() => route.query, (newQuery) => {
  searchStore.setFromQuery(newQuery);
});

watch(() => searchStore.selectedSort, (val) => {
  console.log('Sort changed:', val);
});

watch(() => searchStore.filteredYachts, (val) => {
  console.log('Filtered yachts:', val);
});
watch(() => searchStore.currentPage, () => {
  nextTick(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
});


</script>

<template>
  <YachtsHero />

<SearchResults/>

  <div class="container mx-auto pt-24 place-items-center">
    <div v-if="searchStore.loading" class="grid place-content-center mt-10">
      <VueSpinner size="30" color="#beA5aa" />
    </div>
    <div v-else class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mx-auto">
      <div
        v-for="(yacht, index) in searchStore.paginatedYachts"
        :key="`${yacht.id}`"
      >
        <CharterYachtComponent
            :yacht="yacht"
            :index="index"
            @on-view-details-click="yachtStore.viewYachtDetails(yacht.slug)"
        />
      </div>
    </div>

    <!-- Pagination -->
    <div v-if="searchStore.filteredYachts.length && !searchStore.loading" class="mt-15 flex justify-center">
      <VueAwesomePaginate
          :total-items="searchStore.filteredYachts.length"
          :items-per-page="searchStore.yachtsPerPage"
          :max-pages-shown="isMobileSmall ? 1 : 3"
          v-model="searchStore.currentPage"
      />
    </div>
  </div>

</template>

<style scoped>

</style>
